import script from "./CopilotBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopilotBar.vue?vue&type=script&setup=true&lang=ts"

import "./CopilotBar.vue?vue&type=style&index=0&id=5d1647aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1647aa"]])

export default __exports__